// @mui material components
import React, { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";

import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import IconButton from "@mui/material/IconButton";

import TimelineItem from "examples/Timeline/TimelineItem";
import ServicesEditList from "./ServicesEditList";
import toast from "react-hot-toast";
import { capitalCase } from "capital-case";
import { useForm, Controller } from "react-hook-form";

// Data
import { MANUFACTURER_SERVICES } from "utils/data";

const ServicesWeOffer = ({ store, updateStore, editable = true }) => {
  const [editVisible, setEditVisible] = useState(false);

  const { register, handleSubmit, trigger, setValue, getValues, reset, errors, control } = useForm(
    {}
  );

  const handleShowEdit = (e) => {
    setEditVisible(true);
  };

  const handleSave = async (data) => {
    const payload = {
      metadata: {
        services: data["services"],
        servicesDescription: data["servicesDescription"],
      },
    };
    try {
      await updateStore(payload);
      toast.success("Update provided services successfully!");
      setEditVisible(false);
    } catch (err) {
      console.log(err);
      return toast.error("Update provided services failed!");
    }
  };

  //Ideation, Sourcing, Technical Design, Sampling, Production
  const renderTimelineItems = MANUFACTURER_SERVICES.map((s, index) => {
    let services_offered = store?.metadata?.services_offered || {};

    let badges =
      services_offered[s.value] && services_offered[s.value]["tags"]
        ? services_offered[s.value]["tags"]
        : [];
    let description =
      services_offered[s.value] && services_offered[s.value]["descriptions"]
        ? services_offered[s.value]["descriptions"]
        : " ";

    return (
      <TimelineItem
        key={index}
        isEmpty={!services_offered.hasOwnProperty(s.value)}
        color={s.color}
        title={s.label}
        icon={s.icon}
        description={description}
        badges={badges}
        badgeTitle="Services:"
        lastItem={index + 1 == MANUFACTURER_SERVICES.length}
      />
    );
  });

  return (
    <Card>
      <form onSubmit={handleSubmit(handleSave)}>
        <div className="m-4">
          <div className="my-2 flex justify-between">
            <SuiTypography variant="h6" fontWeight="medium" textTransform="capitalize">
              Services We Offer
            </SuiTypography>
            {editable &&
              (editVisible ? (
                <div className="flex">
                  <Tooltip title={"Cancel"} placement="top">
                    <IconButton
                      aria-label="clear"
                      size="small"
                      onClick={() => setEditVisible(false)}
                    >
                      <ClearIcon color="error" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={"Save"} placement="top">
                    <IconButton aria-label="done" size="small" type="submit">
                      <DoneIcon color="success" />
                    </IconButton>
                  </Tooltip>
                </div>
              ) : (
                <Tooltip title={"Edit"} placement="top">
                  <IconButton aria-label="edit" size="small" onClick={handleShowEdit}>
                    <EditIcon color="dark" />
                    <SuiTypography
                      variant="h6"
                      fontWeight="bold"
                      textTransform="uppercase"
                      sx={{ ml: 1, fontSize: 14 }}
                      className="xsmall:hidden small:inline"
                    >
                      EDIT
                    </SuiTypography>
                  </IconButton>
                </Tooltip>
              ))}
          </div>
          {editVisible ? (
            <ServicesEditList store={store} register={register} setValue={setValue} />
          ) : (
            renderTimelineItems
          )}
        </div>
      </form>
    </Card>
  );
};

export default ServicesWeOffer;
